export default __webpack_public_path__ + "static/media/headphone_blue.656a82d8.svg";